
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class PromoCodeModal extends Vue {
    @Prop({
        type: Boolean,
        required: true,
    })
    public value!: boolean;

    public promoCode = '';
    public validating = false;
    public errorMessage = '';

    get dialogOpen() {
        return this.value;
    }

    set dialogOpen(val: boolean) {
        this.$emit('input', val);
    }

    get dialogMaxWidth(): string {
        return '340px';
    }

    get dialogMinWidth(): string | undefined {
        return '340px';
    }

    closeModal() {
        this.dialogOpen = false;
        this.resetForm();
    }

    resetForm() {
        this.promoCode = '';
        this.errorMessage = '';
        this.validating = false;
    }

    async applyPromoCode() {
        if (!this.promoCode.trim()) return;

        this.validating = true;
        this.errorMessage = '';

        try {
            // Simulate API call to validate promo code
            await new Promise(resolve => setTimeout(resolve, 2000));

            // Valid promo code
            if (this.promoCode.toUpperCase() === 'PAPIERZ') {
                // Emit success event with special message for free sessions
                this.$emit('promo-applied', '21,37 SESJI GRATIS');
                this.closeModal();
            } else {
                this.errorMessage = 'Nieprawidłowy kod promocyjny';
            }

        } catch (error) {
            console.error('Promo code validation failed:', error);
            this.errorMessage = 'Wystąpił błąd podczas weryfikacji kodu';
        } finally {
            this.validating = false;
        }
    }
}
